
// Here we are overriding MediaFile from nuxt-typo3
import { Vue, Component, Prop } from 'nuxt-property-decorator';
import type { PropType } from 'vue';
import BaseMediaFile from './File';
import { ColPosAppearance } from '@/types/pageContract';
import { File, ImageMetaData } from '@/types/contentContract';

@Component({
  extends: BaseMediaFile
})
export default class MediaFile extends Vue implements BaseMediaFile {
  @Prop({ type: Object, required: true })
  file!: File;

  @Prop({ type: Object, required: true })
  responsive!: any;

  @Prop({ type: String, default: '' })
  mediaLabel!: string;

  @Prop({ type: Object as PropType<ImageMetaData>, default: () => {} })
  imageMetaData!: ImageMetaData;

  @Prop({ type: Number, required: true })
  maxGalleryWidth!: number;

  @Prop({ type: Boolean, default: false })
  equalMediaHeight!: boolean;

  @Prop({ type: Object as PropType<ColPosAppearance>, default: () => {} })
  appearance!: ColPosAppearance;
}
